// extracted by extract-css-chunks-webpack-plugin
module.exports = {"bidding-console":"bidding-console___33TXs"};